<maced-footer [links]="links" logoOpenInNewWindow="open in new tab" logoImg="./assets/default/images/footer_logo.svg" [logoHyperLink]="meeUrl"
  logoImageAltName="Macmillan Education" [copyright]="copyright" [logoWidth] = 150 [logoHeight] = 42>
</maced-footer>